import React from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { getJobMessages } from '../../../../constants/messages';
import { ActiveDeviceSearch } from '../../actions';
import Device from '../../AddUpdateJob/CommonComponents/Device';
import { JOBSTATUS } from '../../constants';
import BasicInformation from '../DefaultViews/BasicInformation';
import DescriptionsCombiner from '../DefaultViews/DescriptionsCombiner';
import DeviceRender from '../DefaultViews/DeviceRender';
import MissingWON from '../DefaultViews/MissingWON';
const { TODO, DOING, MISSINGWON, DONE, CANCELLED, ANNULLED, PROFORMA, INVOICED } = JOBSTATUS;

let jobMessages = getJobMessages();

const messages = {
	...jobMessages,
};

class Revision extends React.Component {
	getIntl = (str, values = {}) => this.props.intl.formatMessage({ ...messages[str] }, values);

	renderTodo = () => {
		const { getField } = this.props;
		return <BasicInformation getField={getField} />;
	};

	renderDeviceSelector = () => {
		const { form, saveFields, getField } = this.props;
		const save = (gps) => saveFields({ gps });
		const gps = getField('gps');
		const clientId = getField('client.clientId');
		return (
			<Device
				form={form}
				search={(deviceName) => ActiveDeviceSearch(deviceName, clientId, 10)}
				device={gps}
				disabled={clientId === undefined}
				onChange={save}
			/>
		);
	};

	renderDevice = () => {
		const device = this.props.getField('gps');
		if (device) return <DeviceRender device={device} />;
	};

	renderDoing = () => {
		const { renderTodo, renderDeviceSelector } = this;
		return (
			<div>
				{renderTodo()}
				{renderDeviceSelector()}
			</div>
		);
	};

	renderDone = () => {
		const { renderTodo, renderDevice } = this;
		return (
			<DescriptionsCombiner>
				{renderTodo()}
				{renderDevice()}
			</DescriptionsCombiner>
		);
	};

	renderMissingWON = () => {
		const { props, renderDone } = this;
		const { form, jobId } = props;
		return <MissingWON form={form} jobId={jobId} renderInfo={renderDone} />;
	};

	renderBasedOnStatus = () => {
		const { props, getIntl, renderTodo, renderDoing, renderDone, renderMissingWON } = this;
		const { getField } = props;
		const status = getField('status');
		switch (status) {
			case TODO.id:
			case CANCELLED.id:
			case ANNULLED.id:
				return renderTodo();
			case DOING.id:
				return renderDoing();
			case INVOICED.id:
			case PROFORMA.id:
			case DONE.id:
				return renderDone();
			case MISSINGWON.id:
				return renderMissingWON();
			default:
				return <div>{getIntl('noStatusFormForType')}</div>;
		}
	};

	render() {
		return this.renderBasedOnStatus();
	}
}

Revision.propTypes = {
	intl: PropTypes.object.isRequired,
	form: PropTypes.object.isRequired,
	saveFields: PropTypes.func.isRequired,
	getField: PropTypes.func.isRequired,
	jobId: PropTypes.number.isRequired,
};

export default injectIntl(Revision);
